import api from '../config/api';

export interface Notification {
  id: string;
  orderId: string;
  notificationType: string;
  recipientType: string;
  messageTemplate: string;
  status: string;
  read: boolean;
  readAt?: string | null;
  createdAt: string;
  order: {
    id: string;
    orderNumber: string;
    status: string;
    vehicle?: {
      carPlateNumber?: string;
      model?: {
        name: string;
      };
      year: number;
    };
  };
}

export const notificationService = {
  async getNotifications(limit: number = 50): Promise<Notification[]> {
    const response = await api.get(`/notifications?limit=${limit}`);
    return response.data.data;
  },

  async getUnreadCount(): Promise<number> {
    const response = await api.get('/notifications/unread-count');
    return response.data.count;
  },

  async markAsRead(notificationId: string): Promise<void> {
    await api.post(`/notifications/${notificationId}/read`);
  },
};

